import styled from "styled-components";
import { mobile } from "../utilities/responsive";

import Typewriter from "./Typewriter";

import githubIcon from "../assets/github.png";
import sendIcon from "../assets/send.png";
import linkedinIcon from "../assets/linkedin.png";

const Container = styled.div`
  height: 60px;
  position: fixed;
  width: 90vw;
  margin: 1% auto;
  left: 0;
  right: 0;
  transform: translateX(30px);
  border-radius: 2rem;
  z-index: 999;
  background-color: white;
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.8);

  ${mobile({
    display: "none",
  })}
`;

const Wrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-family: Arial, Helvetica, sans-serif;

  ${mobile({ display: "none" })}
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 1.5em;
  color: #990000;
  ${mobile({ display: "none" })}
`;

const Center = styled.div`
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const LinkItem = styled.a`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  padding-bottom: 4px;
  font-weight: 500;
  letter-spacing: 0.12em;
  font-size: 1rem;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 0;
    height: 2px;
    background: #111;
    transform: translateX(-50%);
    transition: width 0.45s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${mobile({ flex: 2, justifyContent: "space-around" })}
`;

const SocialContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
`;

const Icon = styled.img`
  width: 40px;
  height: 40px;
  margin: 0 5px;
  cursor: pointer;
  transition: transform 0.25s ease;

  &:hover {
    transform: translateY(-3px);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    &:hover { transform: none; }
  }
`;

const ConnectButton = styled.a`
  width: 100px;
  height: 40px;
  border: 2px solid black;
  cursor: pointer;
  border-radius: 2rem;
  padding: 5px;
  font-size: small;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  color: inherit;
  text-decoration: none;
  box-sizing: border-box;

  transition:
    color 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    background: linear-gradient(
      115deg,
      #00c6ff 0%,
      #2f7bff 25%,
      #9d50bb 50%,
      #ff6ec4 75%,
      #00c6ff 100%
    );
    background-size: 300% 300%;
    border-color: rgba(255, 255, 255, 0.65);
    color: #fff;
    animation: holoShift 3s ease-in-out infinite;
    box-shadow:
      0 0 16px rgba(0, 198, 255, 0.5),
      0 0 42px rgba(157, 80, 187, 0.35);
  }

  @keyframes holoShift {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

const Navbar = () => {
  return (
    <Container>
      <Wrapper>
        <Left>
          I'm
          <Typewriter />
        </Left>
        <Center>
          <LinkItem href="#home">Home</LinkItem>
          <LinkItem href="#projects">Experience</LinkItem>
          <LinkItem href="#reviews">Feedback</LinkItem>
          <LinkItem href="/resume.pdf" target="_blank">
            Resume
          </LinkItem>
        </Center>
        <Right>
          <SocialContainer>
            <SocialLink
              href="https://github.com/Ashcoca"
              target="_blank"
              rel="noreferrer"
            >
              <Icon src={githubIcon} alt="GitHub" />
            </SocialLink>
            <SocialLink
              href="https://www.linkedin.com/in/ashvin-coca"
              target="_blank"
              rel="noreferrer"
            >
              <Icon src={linkedinIcon} alt="LinkedIn" />
            </SocialLink>
            <SocialLink
              href="https://mailhide.io/e/kWBSwZsz"
              target="_blank"
              rel="noreferrer"
              onClick={(e) => {
                const popup = window.open(
                  "https://mailhide.io/e/kWBSwZsz",
                  "mailhidepopup",
                  "width=580,height=635",
                );
                if (popup) e.preventDefault();
              }}
            >
              <Icon src={sendIcon} alt="Email" />
            </SocialLink>
          </SocialContainer>
          <ConnectButton
            href="https://mailhide.io/e/kWBSwZsz"
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
              const popup = window.open(
                "https://mailhide.io/e/kWBSwZsz",
                "mailhidepopup",
                "width=580,height=635",
              );
              if (popup) e.preventDefault();
            }}
          >
            Let's Connect
          </ConnectButton>
        </Right>
      </Wrapper>
    </Container>
  );
};

export default Navbar;
